// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__TnK3G","modal":"Modal_modal__TSF3w","slide-down":"Modal_slide-down__ydLlU"};